// extracted by mini-css-extract-plugin
module.exports = {"gradientOverlayRight":"ImageOverlay_gradientOverlayRight__MutM_","gradientOverlayLeft":"ImageOverlay_gradientOverlayLeft__OBlUs"};